module.exports = __webpack_public_path__ + "img/prestige+.2be0be73.jpg";